import React from "react";
import { CheckCircle2, XCircle } from "lucide-react";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const shortDate = (iso) => { const d = new Date(iso || ""); return Number.isNaN(d.getTime()) ? "—" : `${d.getDate()} ${MONTHS[d.getMonth()]}`; };

// Live onboarding verdict for one supplier (shape: /admin/onboarding/progress items[]).
export default function OnboardingProgressCard({ s }) {
  return (
    <div className="mt-3 bg-white border border-[#E8ECE9] p-3" data-testid={`progress-result-${s.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div><span className="text-sm text-[#11211A] font-medium">{s.company || s.email}</span> <span className="text-[11px] text-[#7D8C85]">· {s.email} · {s.tier || "free"}</span></div>
        <div className={`font-serif text-xl ${s.complete ? "text-[#264839]" : "text-[#B35C4A]"}`} data-testid={`progress-percent-${s.id}`}>{s.percent}% {s.complete && <span className="text-[10px] uppercase tracking-wider align-middle ml-1">complete</span>}</div>
      </div>
      <ul className="mt-2 grid sm:grid-cols-2 gap-1.5 text-xs">
        {Object.entries(s.steps).map(([sid, st]) => (
          <li key={sid} className={`flex items-center gap-1.5 ${st.done ? "text-[#264839]" : "text-[#B35C4A]"}`} data-testid={`progress-step-${s.id}-${sid}`}>
            {st.done ? <CheckCircle2 className="w-3.5 h-3.5" /> : <XCircle className="w-3.5 h-3.5" />} {st.title} — {st.done ? "done" : "missing"}
          </li>
        ))}
      </ul>
      <div className="mt-2 text-[11px] text-[#7D8C85]" data-testid={`progress-signals-${s.id}`}>
        Signals: account logo {s.signals.user_logo ? "yes" : "no"} · products with images {s.signals.products_with_images} · listings: {s.signals.listings.length === 0 ? "none" : s.signals.listings.map((l, i) => `#${i + 1} ${l.status}${l.has_description ? "" : " · no description"}${l.has_category ? "" : " · no category"}${l.has_image ? "" : " · no image"}${l.has_region ? "" : " · no region"}${l.has_contact ? "" : " · no listing contact"}`).join("; ")}
        {s.nudge.sent_at && <> · nudged {shortDate(s.nudge.sent_at)}{s.nudge.pct_at_send !== undefined && s.nudge.pct_at_send !== null && <> at {s.nudge.pct_at_send}%</>}</>}{s.nudge.snoozed_until && <> · snoozed until {shortDate(s.nudge.snoozed_until)}</>}{s.nudge.completed_at && <> · marked complete {shortDate(s.nudge.completed_at)}</>}
      </div>
      <div className="mt-1.5 text-[11px]" data-testid={`progress-eligibility-${s.id}`}>
        {s.nudge.excluded_paid
          ? <span className="text-[#264839] font-medium">Paid / subscribed customer — permanently excluded from setup nudges.</span>
          : s.nudge.candidate
            ? <span className="text-[#7D8C85]">Eligible for setup nudges while incomplete (free sign-up).</span>
            : <span className="text-[#7D8C85]">Not a nudge candidate (unclaimed directory entry).</span>}
      </div>
      {s.nudge.audit?.length > 0 && (
        <div className="mt-2 border-t border-[#E8ECE9] pt-2 text-[11px] text-[#4A5550]" data-testid={`progress-audit-${s.id}`}>
          <div className="uppercase tracking-widest text-[10px] text-[#7D8C85] mb-1">What the sweep saw when it emailed</div>
          {s.nudge.audit.map((a) => (
            <div key={a.id} data-testid={`progress-audit-row-${a.id}`}>
              {shortDate(a.at)} · {a.kind === "second_chance" ? "second-chance" : "nudge"} {a.sent ? "sent" : "NOT sent"} · {a.done}/{a.total} ({a.percent}%) · missing: {a.missing.length ? a.missing.join(", ") : "none"}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
